<template>
  <v-app
    id="inspire"
    class="gateway-admin"
  >
    <v-navigation-drawer
      v-model="drawer"
      app
      width="272"
      class="gateway-admin__drawer"
      :dark="false"
    >
      <div class="gateway-admin__brand">
        <div
          class="gateway-admin__brand-mark"
          aria-hidden="true"
        >S</div>
        <div class="gateway-admin__brand-copy">
          <div class="gateway-admin__brand-name">{{ info.app_name || "SenderWA" }}</div>
          <div class="gateway-admin__brand-meta">Gateway · v{{ info.app_ver || "1.0" }}</div>
        </div>
      </div>

      <div class="gateway-admin__user">
        <v-avatar
          size="40"
          class="gateway-admin__avatar"
        >
          <v-img
            v-if="user.avatar_path"
            :src="user.avatar_path"
          ></v-img>
          <span v-else>{{ userInitial }}</span>
        </v-avatar>
        <div class="gateway-admin__user-copy">
          <div class="gateway-admin__user-name">{{ user.name }}</div>
          <div class="gateway-admin__user-role">{{ user.authent }}</div>
        </div>
      </div>

      <div class="gateway-admin__nav-scroll">
        <v-list
          dense
          nav
          class="gateway-admin__nav"
        >
          <template v-for="(menu, index) in menus">
            <v-list-item
              v-if="menu.type === 'item'"
              :key="'item-' + index"
              :to="menu.route"
              class="gateway-admin__nav-item"
              active-class="gateway-admin__nav-item--active"
            >
              <v-list-item-icon class="gateway-admin__nav-icon">
                <v-icon small>{{ menu.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ menu.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <div
              v-else-if="menu.type === 'divisi'"
              :key="'divisi-' + index"
              class="gateway-admin__section"
            >
              <v-icon
                small
                class="mr-1"
              >{{ menu.icon }}</v-icon>
              {{ menu.title }}
            </div>

            <div
              v-else-if="menu.type === 'subheader'"
              :key="'sub-' + index"
              class="gateway-admin__section gateway-admin__section--plain"
            >
              {{ menu.title }}
            </div>

            <v-list-group
              v-else-if="menu.type == 'subMenu'"
              :key="'group-' + index"
              class="gateway-admin__group"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ menu.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="(subItem, idx) in menu.submenus">
                <v-list-item
                  v-if="subItem.type === 'item'"
                  :key="'subitem-' + index + '-' + idx"
                  :to="subItem.route"
                  class="gateway-admin__nav-item gateway-admin__nav-item--child"
                  active-class="gateway-admin__nav-item--active"
                >
                  <v-list-item-icon class="gateway-admin__nav-icon">
                    <v-icon small>{{ subItem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-app-bar
      app
      flat
      height="64"
      class="gateway-admin__topbar"
    >
      <v-app-bar-nav-icon
        class="gateway-admin__menu-toggle"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <div class="gateway-admin__topbar-title">
        <div class="gateway-admin__company">
          {{ device.desktop ? info.app_company : info.app_name }}
        </div>
        <div class="gateway-admin__product-line">WhatsApp Gateway Console</div>
      </div>

      <v-spacer></v-spacer>

      <div
        class="gateway-admin__status-chip"
        :class="waConnected ? 'is-online' : 'is-idle'"
      >
        <span class="gateway-admin__status-dot"></span>
        {{ waConnected ? "Sesi terhubung" : "Siap kirim" }}
      </div>

      <v-menu
        v-model="menu"
        :close-on-content-click="true"
        offset-y
        left
        bottom
        :max-width="260"
        content-class="gateway-admin__account-menu-wrap"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            class="gateway-admin__account-btn ml-2"
            v-bind="attrs"
            v-on="on"
          >
            <v-avatar
              size="32"
              class="gateway-admin__avatar mr-2"
            >
              <v-img
                v-if="user.avatar_path"
                :src="user.avatar_path"
              ></v-img>
              <span v-else>{{ userInitial }}</span>
            </v-avatar>
            <span
              v-if="device.desktop"
              class="gateway-admin__account-name"
            >{{ user.name }}</span>
            <v-icon
              small
              class="ml-1"
            >mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-card class="gateway-admin__account-menu">
          <div class="gateway-admin__account-head">
            <div class="gateway-admin__user-name" :title="user.name">
              {{ user.name }}
            </div>
            <div class="gateway-admin__user-role">{{ user.authent }}</div>
          </div>
          <v-divider></v-divider>
          <v-list dense class="gateway-admin__account-list">
            <v-list-item @click="$router.push({ name: 'profil-akun' })">
              <v-list-item-icon class="mr-3">
                <v-icon small color="#1f7a57">mdi-account-edit-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Profil Akun</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push({ name: 'chngpwd' })">
              <v-list-item-icon class="mr-3">
                <v-icon small color="#1f7a57">mdi-account-key</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Ganti Kata Sandi</v-list-item-title>
            </v-list-item>
            <v-divider class="my-1"></v-divider>
            <v-list-item class="gateway-admin__logout-item" @click="signout">
              <v-list-item-icon class="mr-3">
                <v-icon small color="#b42318">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="gateway-admin__logout-text">
                Keluar
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-main class="gateway-admin__main">
      <div
        v-show="page.title"
        class="gateway-admin__pagehead"
      >
        <div>
          <h1 class="gateway-admin__page-title">{{ page.title }}</h1>
          <p
            v-if="page.subtitle"
            class="gateway-admin__page-subtitle"
          >
            {{ page.subtitle }}
          </p>
        </div>
        <v-breadcrumbs
          v-show="device.desktop"
          :items="page.breadcrumbs"
          class="gateway-admin__crumbs"
        >
          <template v-slot:divider>
            <v-icon
              small
              color="#1f7a57"
            >mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </div>

      <div class="gateway-admin__content">
        <router-view></router-view>
      </div>
    </v-main>

    <footer
      class="gateway-admin__footer"
      :class="{ 'is-with-drawer': drawer && device.desktop }"
    >
      <div class="gateway-admin__footer-inner">
        <span class="gateway-admin__footer-status">
          Status:
          <b>{{
            dialog.delete
              ? "Hapus Data"
              : form.add
              ? form.edit
                ? "Ubah data"
                : "Tambah data"
              : "Ready"
          }}</b>
          <span v-show="page.showtable">
            · Records: <b>{{ records.length }}</b>
          </span>
        </span>

        <div
          v-show="device.desktop && page.showtable"
          class="gateway-admin__footer-pager"
        >
          <v-select
            label=""
            dense
            hide-details
            outlined
            :color="theme.color"
            :items="perpages"
            v-model="table.options.itemsPerPage"
            style="max-width: 90px"
          ></v-select>
          <v-pagination
            :color="theme.color"
            v-model="table.options.page"
            :length="table.options.pageCount"
            :total-visible="6"
          ></v-pagination>
        </div>

        <span
          v-show="device.desktop"
          class="gateway-admin__footer-copy"
        >
          © {{ new Date().getFullYear() }} {{ info.app_company }}
        </span>
      </div>
    </footer>

    <!-- Notifikasi & konfirmasi memakai SweetAlert (plugins/swal.js) -->

    <!-- Overlay proses: spinner + backdrop -->
    <v-overlay
      :value="loading.dialog"
      color="#0b3d2e"
      opacity="0.55"
      z-index="300"
      class="gw-spinner-overlay"
    >
      <div class="gw-spinner" role="status" aria-live="polite">
        <v-progress-circular
          indeterminate
          color="#8fd6b5"
          size="52"
          width="4"
        ></v-progress-circular>
        <div class="gw-spinner__text">
          {{ loading.text || "Memproses…" }}
        </div>
      </div>
    </v-overlay>

    <!-- Upload progress: spinner + persen -->
    <v-overlay
      :value="upload.progress"
      color="#0b3d2e"
      opacity="0.55"
      z-index="301"
      class="gw-spinner-overlay"
    >
      <div class="gw-spinner" role="status" aria-live="polite">
        <v-progress-circular
          :value="upload.percent || 0"
          color="#8fd6b5"
          size="64"
          width="5"
        >
          <span class="gw-spinner__pct">{{ upload.percent || 0 }}%</span>
        </v-progress-circular>
        <div class="gw-spinner__text">Mengunggah berkas…</div>
      </div>
    </v-overlay>

    <div class="upload-wrapper">
      <div id="upload-button"></div>
    </div>

    <div class="text-center">
      <v-dialog
        v-model="update.status"
        persistent
        width="500"
      >
        <v-card>
          <v-card-title :class="theme.color + ` darken-1 pa-2 white--text subtitle-1`">
            <v-icon
              color="white"
              class="mr-2"
            >mdi-information-outline</v-icon>
            UPDATE INFORMATION
          </v-card-title>
          <v-card-title>{{ update.title }}</v-card-title>
          <v-card-text>
            <div class="subtitle-1">Versi : {{ update.version }}</div>
          </v-card-text>
          <v-card-text>
            <p>{{ update.description }}</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row class="justify-end pa-5">
              <v-btn
                color="#1f7a57"
                dark
                @click="update.status = false"
              >OK</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
import { baseMixins } from "../../mixings/BaseMixins";
import { mapActions, mapState } from "vuex";
import { io } from "socket.io-client";
import { domainURL } from "../../.env";

export default {
  data: () => ({
    drawer: null,
    vertical: true,
    bg: "",
    update: {
      status: false,
      title: null,
      description: null,
      version: null,
    },
    menu: false,
    perpages: [
      { text: 10, value: 10 },
      { text: 15, value: 15 },
      { text: 25, value: 25 },
      { text: 50, value: 50 },
    ],
    socket: null,
  }),

  mixins: [baseMixins],

  computed: {
    ...mapState([
      "snackbar",
      "theme",
      "thememode",
      "dialog",
      "user",
      "menus",
      "page",
      "form",
      "device",
      "loading",
      "upload",
      "info",
      "http",
      "table",
      "records",
      "channel",
      "whatsapp",
    ]),
    userInitial() {
      const name = (this.user && this.user.name) || "S";
      return String(name).charAt(0).toUpperCase();
    },
    waConnected() {
      return !!(
        this.whatsapp &&
        this.whatsapp.authenticated &&
        this.whatsapp.authenticated.status
      );
    },
  },
  created() {
    this.bg = this.page.domainUrl + "images/bg-nav-purple-3.jpg";
  },
  mounted() {
    this.getAppInfo().then(() => {
      window.document.title = this.info.app_company;
      const favicon = window.document.getElementById("favicon");
      if (favicon) favicon.href = this.info.app_logo;
    });
    this.getMenus();
    this.getUserInfo().then(() => {
      this.openSocket();
    });
    this.sleep(500).then(() => {
      this.setPage({
        drawer: this.device.desktop,
      });
    });
  },
  methods: {
    ...mapActions([
      "signOut",
      "snackbarClose",
      "postDelete",
      "postBulkDelete",
      "dialogDeleteClose",
      "dialogBulkDeleteClose",
      "fetchRecords",
      "initUploadLibrary",
      "getUserInfo",
      "getMenus",
      "clearMenu",
      "getAppInfo",
      "setLoading",
      "setPage",
      "setTable",
      "setWaQr",
      "setWaAuth",
    ]),

    signout: function () {
      this.clearMenu();
      this.signOut();
      this.$router.push({ name: "login" });
    },
    deleteRecord: function () {
      this.postDelete().then(() => {
        this.dialogDeleteClose();
      });
    },
    bulkDeleteRecord: function () {
      this.postBulkDelete().then(() => {
        this.dialogBulkDeleteClose();
      });
    },
    checkUpdate: async function () {
      try {
        let {
          data: { status, message, data },
        } = await this.http.get("api/utility/check-update");
        this.update.title = data.title;
        this.update.description = data.description;
        this.update.status = status;
        this.update.version = data.version;
      } catch (error) {
        console.error;
      }
    },
    sleep: function (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    openSocket: async function () {
      // Prod: https://wa.sendertechid.com + path /service/socket.io
      const url_loc =
        domainURL.SOCKET ||
        (this.page && this.page.domainUrl) ||
        domainURL.BASE ||
        window.location.origin;
      this.socket = new io(url_loc, {
        path: domainURL.SOCKET_PATH || "/socket.io",
        autoConnect: true,
        transports: ["websocket", "polling"],
      });

      this.socket.on(this.channel + ":sended", (data) => {
        this.snackbar.color = this.theme.color;
        this.snackbar.text = data.message;
        this.snackbar.state = true;
      });

      this.socket.on(this.channel + ":inbox", (data) => {
        this.snackbar.color = "#1f7a57";
        this.snackbar.text =
          "Pesan masuk dari " +
          (data.sender_number || "kontak") +
          ": " +
          (data.content || "");
        this.snackbar.state = true;
      });

      this.socket.on(this.channel + ":qr", (data) => {
        const payload = {
          id: data.id,
          src: data.src,
          show: data.show,
          message: data.message,
        };
        this.setWaQr(payload);
      });

      this.socket.on(this.channel + ":authenticated", (data) => {
        if (data && (data.show === false || !data.id)) {
          this.setWaAuth({ clear: true, show: false });
          return;
        }

        const payload = {
          id: data.id,
          name: data.name,
          status: data.status || "Terhubung",
          image: data.image || "/images/ok.png",
          show: true,
        };

        this.setWaAuth(payload);
      });
    },
  },
};
</script>

<style lang="sass">
@import "../../assets/css/wow.css"
</style>

<style>
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@500;600;700&family=Source+Sans+3:wght@400;500;600&display=swap");

.gateway-admin {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-paper: #f8fbf9;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
  font-family: "Source Sans 3", "Montserrat", sans-serif;
  color: var(--gw-ink);
}

.gateway-admin__drawer {
  background: radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%) !important;
  border-right: 0 !important;
}

.gateway-admin__brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.25rem 1.1rem 1rem;
}

.gateway-admin__brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.15rem;
  color: #0b3d2e;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.gateway-admin__brand-name {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
  color: #f4fbf7;
  line-height: 1.2;
}

.gateway-admin__brand-meta {
  margin-top: 0.15rem;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(244, 251, 247, 0.6);
}

.gateway-admin__user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0 0.9rem 0.85rem;
  padding: 0.75rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.gateway-admin__avatar {
  background: rgba(143, 214, 181, 0.25) !important;
  color: #f4fbf7 !important;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
}

.gateway-admin__user-name {
  font-weight: 600;
  font-size: 0.92rem;
  color: #f4fbf7;
  line-height: 1.2;
}

.gateway-admin__user-role {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  text-transform: capitalize;
  color: rgba(244, 251, 247, 0.65);
}

.gateway-admin__nav-scroll {
  height: calc(100vh - 168px);
  overflow-y: auto;
  padding: 0 0.45rem 1.5rem;
}

.gateway-admin__nav {
  background: transparent !important;
}

.gateway-admin__section {
  display: flex;
  align-items: center;
  margin: 1rem 0.55rem 0.4rem;
  padding: 0.35rem 0.45rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--gw-mint);
}

.gateway-admin__section--plain {
  color: rgba(244, 251, 247, 0.55);
}

.gateway-admin__nav-item {
  margin-bottom: 0.2rem !important;
  border-radius: 10px !important;
  min-height: 40px !important;
  color: rgba(244, 251, 247, 0.86) !important;
}

.gateway-admin__nav-item .v-list-item__title {
  font-size: 0.9rem !important;
  font-weight: 500 !important;
}

.gateway-admin__nav-icon {
  margin-right: 10px !important;
  min-width: 24px !important;
}

.gateway-admin__nav-icon .v-icon {
  color: rgba(244, 251, 247, 0.72) !important;
}

.gateway-admin__nav-item:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}

.gateway-admin__nav-item--active {
  background: rgba(143, 214, 181, 0.18) !important;
  color: #fff !important;
}

.gateway-admin__nav-item--active .v-icon {
  color: var(--gw-mint) !important;
}

.gateway-admin__nav-item--child {
  padding-left: 12px !important;
}

.gateway-admin__group .v-list-group__header {
  border-radius: 10px !important;
  color: rgba(244, 251, 247, 0.9) !important;
}

.gateway-admin__group .v-list-group__header .v-list-item__title {
  font-size: 0.9rem !important;
  font-weight: 500 !important;
}

.gateway-admin__group .v-list-group__header:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}

.gateway-admin__topbar {
  background: rgba(248, 251, 249, 0.92) !important;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--gw-line) !important;
  color: var(--gw-ink) !important;
}

.gateway-admin__menu-toggle {
  color: var(--gw-forest) !important;
}

.gateway-admin__topbar-title {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.gateway-admin__company {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 1rem;
  color: var(--gw-ink);
}

.gateway-admin__product-line {
  font-size: 0.72rem;
  color: var(--gw-muted);
}

.gateway-admin__status-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid var(--gw-line);
  background: #fff;
  color: var(--gw-muted);
}

.gateway-admin__status-chip.is-online {
  border-color: rgba(31, 122, 87, 0.25);
  background: rgba(143, 214, 181, 0.2);
  color: var(--gw-forest);
}

.gateway-admin__status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #91a59b;
}

.gateway-admin__status-chip.is-online .gateway-admin__status-dot {
  background: var(--gw-leaf);
  box-shadow: 0 0 0 3px rgba(31, 122, 87, 0.15);
}

.gateway-admin__account-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  color: var(--gw-ink) !important;
  min-width: 0 !important;
}

.gateway-admin__account-name {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  font-size: 0.88rem;
}

.gateway-admin__account-menu-wrap {
  max-width: min(260px, calc(100vw - 16px)) !important;
}

.gateway-admin__account-menu {
  width: 240px !important;
  max-width: 100% !important;
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid var(--gw-line);
}

.gateway-admin__account-head {
  padding: 0.9rem 1rem;
  background: var(--gw-fog);
  min-width: 0;
}

.gateway-admin__account-head .gateway-admin__user-name {
  color: var(--gw-ink);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gateway-admin__account-head .gateway-admin__user-role {
  color: var(--gw-muted);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gateway-admin__account-list {
  padding: 0.35rem 0 !important;
}

.gateway-admin__account-list .v-list-item__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gateway-admin__logout-text {
  color: #b42318 !important;
  font-weight: 700 !important;
}

.gateway-admin__main {
  background: radial-gradient(
      80% 50% at 100% 0%,
      rgba(143, 214, 181, 0.18),
      transparent 55%
    ),
    var(--gw-paper) !important;
  padding-bottom: 56px !important;
}

.gateway-admin__pagehead {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.35rem 0.85rem;
  border-bottom: 1px solid var(--gw-line);
  background: rgba(255, 255, 255, 0.55);
}

.gateway-admin__page-title {
  margin: 0;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--gw-ink);
}

.gateway-admin__page-subtitle {
  margin: 0.25rem 0 0;
  font-size: 0.88rem;
  color: var(--gw-muted);
}

.gateway-admin__crumbs {
  padding: 0 !important;
}

.gateway-admin__content {
  min-height: calc(100vh - 180px);
  padding: 1rem 1.15rem 1.5rem;
  overflow-y: auto;
}

.gateway-admin__footer {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  width: auto;
  background: #fff;
  border-top: 1px solid var(--gw-line);
  transition: left 0.2s ease;
}

.gateway-admin__footer.is-with-drawer {
  left: 272px;
}

.gateway-admin__footer-inner {
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.35rem 1.15rem;
  font-size: 0.78rem;
  color: var(--gw-muted);
}

.gateway-admin__footer-pager {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.gateway-admin__footer-copy {
  margin-left: auto;
}

@media (max-width: 960px) {
  .gateway-admin__status-chip {
    display: none;
  }

  .gateway-admin__pagehead {
    flex-direction: column;
    align-items: flex-start;
  }

  .gateway-admin__content {
    padding: 0.85rem;
  }

  .gateway-admin__footer-inner {
    flex-wrap: wrap;
  }

  .gateway-admin__footer-copy {
    margin-left: 0;
  }
}
</style>
